export const getDefaultCustomLegendMapping = [
  {
    section_name: 'Transportation',
    section_details: [
      {
        type: 'group',
        group_name: 'Transit',
        visible: false,
        defaultopacity: 0.95,
        opacity: 0.95,
        isOpacityControlOpen: false,
        collpsed: true,
        group_details: [
          {
            type: 'sub_group',
            sub_group_name: 'Transit Stops',
            sub_group_details: [
              {
                type: 'layer',
                layer_name: 'BCT bus stop',
                layer_id: 'browardBusStopLayer',
                visible: false,
                isDiffColored: false,
                legend_type: 'icon',
                legend_value: require('../../assets/bus.png'),
              },
              {
                type: 'layer',
                layer_name: 'Train stop',
                layer_id: 'browardTrainStopLayer',
                visible: false,
                isDiffColored: false,
                legend_type: 'icon',
                legend_value: require('../../assets/train.png'),
              },
            ],
          },
          {
            type: 'sub_group',
            sub_group_name: 'Transit Routes',
            sub_group_details: [
              {
                type: 'layer',
                layer_name: 'BCT bus routes',
                layer_id: 'browardBusRouteLayer',
                visible: false,
                isDiffColored: false,
                legend_type: 'solid_line',
                legend_value: '#7E57C2',
              },
              {
                type: 'layer',
                layer_name: 'Train routes',
                layer_id: 'browardTrainRouteLayer',
                visible: false,
                isDiffColored: false,
                legend_type: 'solid_line',
                legend_value: '#EC407A',
              },
            ],
          },
          {
            type: 'layer',
            layer_name: 'Transit Facilities',
            layer_id: 'browardTransitFacilityLayer',
            visible: false,
            isDiffColored: true,
            legend_type: 'icon',
            legend_label: ['Park and Ride', 'Brightline Station', 'Port Everglades'],
            legend_value: [
              require('../../assets/park_ride_lot.png'),
              require('../../assets/brightline_station.png'),
              require('../../assets/port_everglades.png'),
            ],
          },
        ],
      },
      {
        type: 'layer',
        layer_name: 'PREMO Corridors',
        layer_id: 'browardPremoProjectLayer',
        visible: false,
        defaultopacity: 0.95,
        opacity: 0.95,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'solid_line',
        legend_label: [
          'Future Light Rail West Extension',
          'High Frequency Corridors',
          'Broward Commuter Rail South',
          'Bus Rapid Transit',
          'Light Rail Transit',
        ],
        legend_value: ['#FF99A7', '#009E58', '#E7A614', '#19398A', '#F16477'],
      },
    ],
  },
  {
    section_name: 'Land Use',
    section_details: [
      {
        type: 'layer',
        layer_name: 'City lines',
        layer_id: 'browardCityLineLayer',
        visible: false,
        defaultopacity: 0.95,
        opacity: 0.95,
        isOpacityControlOpen: false,
        isDiffColored: false,
        legend_type: 'dash_line',
        legend_value: '#F16477',
      },
      {
        type: 'layer',
        layer_name: 'Parcels',
        layer_id: 'browardParcelLayer',
        visible: false,
        defaultopacity: 0.95,
        opacity: 0.95,
        isOpacityControlOpen: false,
        isDiffColored: false,
        legend_type: 'point',
        legend_value: '#0064D6',
      },
      {
        type: 'layer',
        layer_name: 'HFA Bond Assignments',
        layer_id: 'browardHFABondLayer',
        visible: false,
        defaultopacity: 0.95,
        opacity: 0.95,
        isOpacityControlOpen: false,
        isDiffColored: false,
        legend_type: 'icon',
        legend_value: require('../../assets/house.png'),
      },
      {
        type: 'layer',
        layer_name: 'Zoning Districts',
        layer_id: 'browardZoningDistrictLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'polygon',
        legend_label: [
          'Agricultural',
          'Commercial',
          'Community Facilities',
          'Conservation',
          'Government',
          'Industrial',
          'Institutional',
          'Miscellaneous',
          'Mixed-use',
          'Open Space',
          'Residential',
          'Rural',
          'Transportation',
          'Water',
        ],
        legend_value: [
          '#4DAD44',
          '#D22909',
          '#158245',
          '#74BD9F',
          '#00512D',
          '#D5D3D5',
          '#19189E',
          '#7A66A8',
          '#652B84',
          '#0BBF7E',
          '#FEF769',
          '#FFD62F',
          '#000000',
          '#315AC7',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Future Land Use',
        layer_id: 'browardFutureLandUseLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'polygon',
        legend_label: [
          'Agricultural',
          'Commercial',
          'Community Facilities',
          'Conservation',
          'Industrial',
          'Open Space',
          'Residential',
          'Rural',
          'Transportation',
          'Water',
        ],
        legend_value: [
          '#367A30',
          '#9E1F07',
          '#0D4F2A',
          '#558A74',
          '#A6A6A6',
          '#088C5D',
          '#CCC654',
          '#CCAB26',
          '#333333',
          '#244394',
        ],
      },
      {
        type: 'group',
        group_name: 'Proposed Development Projects',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        group_details: [
          {
            type: 'layer',
            layer_name: 'Miramar Development Projects',
            layer_id: 'miramarDevelopmentProjectLayer',
            visible: false,
            isDiffColored: false,
            legend_type: 'polygon',
            legend_value: '#ED645A',
          },
          {
            type: 'layer',
            layer_name: 'Proposed Transit Oriented Corridor',
            layer_id: 'miramarPraposedTOCLayer',
            visible: false,
            isDiffColored: false,
            legend_type: 'polygon',
            legend_value: '#CC61B0',
          },
          {
            type: 'layer',
            layer_name: 'Proposed MITAC',
            layer_id: 'miramarPraposedMITACLayer',
            visible: false,
            isDiffColored: false,
            legend_type: 'polygon',
            legend_value: '#764E9F',
          },
        ],
      },
    ],
  },
  {
    section_name: 'Infrastructure Hardening',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Broward MTP Resilience Road Network',
        layer_id: 'browardMTPResilienceRoadNetworkLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [2.99, 4, 4.01, 5, 6, 7, 10],
        legend_value: [
          '#19398A',
          '#F16477',
          '#E7A614',
          '#009E58',
          '#FF99A7',
          '#800080',
          '#4B0082',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Current Flood Zones',
        layer_id: 'currentFloodZonesLayer',
        visible: false,
        defaultopacity: 0.3,
        opacity: 0.3,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'polygon',
        legend_label: [
          '1% Annual Chance Flood Hazard',
          '0.2% Annual Chance Flood Hazard',
        ],
        legend_value: ['#CF1C90', '#E74BB0'],
      },
      {
        type: 'group',
        group_name: 'Sea Level Rise (NOAA)',
        visible: false,
        defaultopacity: 0.3,
        opacity: 0.3,
        isOpacityControlOpen: false,
        collpsed: true,
        group_details: [
          {
            type: 'layer',
            layer_name: 'SLR 2.3 Feet',
            layer_id: 'slr2_3FeetLayer',
            visible: false,
            isDiffColored: false,
            legend_type: 'polygon',
            legend_value: '#2F89EE',
          },
          {
            type: 'layer',
            layer_name: 'SLR 3.4 Feet',
            layer_id: 'slr3_4FeetLayer',
            visible: false,
            isDiffColored: false,
            legend_type: 'polygon',
            legend_value: '#2B85CD',
          },
          {
            type: 'layer',
            layer_name: 'SLR 5.4 Feet',
            layer_id: 'slr5_4FeetLayer',
            visible: false,
            isDiffColored: false,
            legend_type: 'polygon',
            legend_value: '#1C589C',
          },
        ],
      },
      {
        type: 'group',
        group_name: 'Water Storage Capacity & Lines',
        visible: false,
        defaultopacity: 0.95,
        opacity: 0.95,
        isOpacityControlOpen: false,
        collpsed: true,
        group_details: [
          {
            type: 'layer',
            layer_name: 'Water Storage',
            layer_id: 'miramarWaterStorageLayer',
            visible: false,
            isDiffColored: false,
            legend_type: 'point',
            legend_value: '#008695',
          },
          {
            type: 'layer',
            layer_name: 'Water Main Lines',
            layer_id: 'miramarWaterLinesLayer',
            visible: false,
            isDiffColored: false,
            legend_type: 'solid_line',
            legend_value: '#008695',
          },
          {
            type: 'layer',
            layer_name: 'Lift Stations',
            layer_id: 'miramarLiftStationsLayer',
            visible: false,
            isDiffColored: false,
            legend_type: 'point',
            legend_value: '#C77E34',
          },
          {
            type: 'layer',
            layer_name: 'Gravity Sewer',
            layer_id: 'miramarGravitySewerLayer',
            visible: false,
            isDiffColored: false,
            legend_type: 'solid_line',
            legend_value: '#C77E34',
          },
          {
            type: 'layer',
            layer_name: 'Storm Drain Lines',
            layer_id: 'miramarStormDrainLinesLayer',
            visible: false,
            isDiffColored: false,
            legend_type: 'solid_line',
            legend_value: '#2F8AC4',
          },
        ],
      },
      {
        type: 'layer',
        layer_name: 'Land Surface Temperature',
        layer_id: 'landSurfaceTemperatureLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: ['55°F', '58°F', '63°F', '68°F', '70°F'],
        legend_value: ['#ECDA9A', '#EFC47E', '#F3AD6A', '#F7945D', '#F97B57', '#F66356'],
      },
    ],
  },
  {
    section_name: 'Safety',
    section_details: [
       {
        type: 'layer',
        layer_name: 'High Injury Network',
        layer_id: 'highInjuryNetworkLayer',
        visible: false,
        defaultopacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        legend_type: 'solid_line',
        legend_label: ['HIN Line'],
        legend_value: ['#b30000'],
      },
      {
        type: 'layer',
        layer_name: 'High Risk Network',
        layer_id: 'highRiskNetworkLayer',
        visible: false,
        defaultopacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        legend_type: 'solid_line',
        legend_label: ['HRN Line'],
        legend_value: ['#b36200'],
      },
      {
        type: 'group',
        group_name: 'Historical Crash Data',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        group_details: [
          {
            type: 'layer',
            layer_name: 'All Crash',
            layer_id: 'historicalAllCrashLayer',
            visible: false,
            defaultopacity: 0.5,
            isOpacityControlOpen: false,
            collpsed: true,
            isDiffColored: true,
            legend_title: '',
            legend_type: 'polygon',
            legend_label: [
              '1-300',
              '301-600',
              '601-1000',
              '1000+',
            ],
            legend_value: [
              '#FBE6C5',            // 1-300
              '#F5BA98',            // 301-600
              '#DC7176',            // 601-1000
              '#9C3F5D',            // 1000+
            ],
          },
          {
            type: 'layer',
            layer_name: 'Bicyclist Crash',
            layer_id: 'historicalBicyclistCrashLayer',
            visible: false,
            defaultopacity: 0.5,
            isOpacityControlOpen: false,
            collpsed: true,
            isDiffColored: true,
            legend_title: '',
            legend_type: 'polygon',
            legend_label: [
              '1-5',
              '6-10',
              '11-20',
              '20+',
            ],
            legend_value: [
              '#FBE6C5',            // 1-5
              '#F5BA98',            // 6-10
              '#DC7176',            // 11-20
              '#9C3F5D',            // 20+
            ],
          },
          {
            type: 'layer',
            layer_name: 'Pedestrian Crash',
            layer_id: 'historicalPedestrianCrashLayer',
            visible: false,
            defaultopacity: 0.5,
            isOpacityControlOpen: false,
            collpsed: true,
            isDiffColored: true,
            legend_title: '',
            legend_type: 'polygon',
            legend_label: [
              '1-10',
              '11-20',
              '21-30',
              '30+',
            ],
            legend_value: [
              '#FBE6C5',            // 1-10
              '#F5BA98',            // 11-20
              '#DC7176',            // 21-30
              '#9C3F5D',            // 30+
            ],
          }
        ],
      },
       {
        type: 'group',
        group_name: 'KSI Crash Data',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        group_details: [
 {
        type: 'layer',
        layer_name: 'All KSI Crash',
        layer_id: 'ksiCrashLayer',
        visible: false,
        defaultopacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'polygon',
        legend_label: [
          '1-10',
          '11-20',
          '21-30',
          '31+',
        ],
        legend_value: [
          '#FBE6C5',            // 1-10
          '#F5BA98',            // 11-20
          '#DC7176',            // 21-30
          '#9C3F5D',            // 31+
        ],
      },
      {
        type: 'layer',
        layer_name: 'Bicyclist Crash',
        layer_id: 'ksiBicyclistCrashLayer',
        visible: false,
        defaultopacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'polygon',
        legend_label: [
          '1-2',
          '3',
          '4',
          '5+',
        ],
        legend_value: [
          '#FBE6C5',            // 1-2
          '#F5BA98',            // 3
          '#DC7176',            // 4
          '#9C3F5D',            // 5+
        ],
      },
      {
        type: 'layer',
        layer_name: 'Pedestrian Crash',
        layer_id: 'ksiPedestrianCrashLayer',
        visible: false,
        defaultopacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'polygon',
        legend_label: [
          '1-5',
          '6-7',
          '8-10',
          '11+',
        ],
        legend_value: [
          '#FBE6C5',            // 1-5
          '#F5BA98',            // 6-7
          '#DC7176',            // 8-10
          '#9C3F5D',            // 11+
        ],
      },
        ]
      },
      {
        type: 'layer',
        layer_name: 'School',
        layer_id: 'schoolLayer',
        visible: false,
        defaultopacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'icon',
        legend_label: ['School'],
        legend_value: [require('../../assets/school.png')],
      },
       {
        type: 'layer',
        layer_name: 'Park',
        layer_id: 'parkLayer',
        visible: false,
        defaultopacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_title: '',
        legend_type: 'polygon',
        legend_label: ['Park'],
        legend_value: ['#008000'],
      }
    ],
  },
  {
    section_name: 'Live Waze Data',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Waze Alerts',
        layer_id: 'wazeAlertsLayer',
        visible: false,
        defaultopacity: 0.9,
        opacity: 0.9,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'point',
        legend_label: ['Congestion', 'Collision', 'Hazard', 'Road Closure'],
        legend_value: ['rgba(116, 78, 161, 1)', 'rgba(35, 96, 220, 1)', 'rgba(236, 182, 0, 1)', 'rgba(222, 61, 115, 1)'],
      },
    ],
  },
  {
    section_name: 'Demographics',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Population',
        layer_id: 'populationLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: ['1000', '2000', '2500', '3000', '4000'],
        legend_value: ['#FBE6C5', '#F5BA98', '#DC7176', '#C8586C', '#9C3F5D', '#70284A'],
      },
      {
        type: 'layer',
        layer_name: 'Income',
        layer_id: 'incomeLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: ['$35K', '$50K', '$65K', '$80K', '$100K'],
        legend_value: ['#EBFAEB', '#B5F0B5', '#7BEB7B', '#0FD510', '#089E05', '#006400'],
      },
      {
        type: 'layer',
        layer_name: '2050 Household Population Density',
        layer_id: 'householdPopulationDensityAcresLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-0.01, 0, 4.81, 9.56, 13.55, 18.75, 1582.55],
        legend_value: [
          '#B22222',
          '#FF6666',
          '#E0E0FF',
          '#B4D2FF',
          '#99CCFF',
          '#3399FF',
          '#3366FF',
          '#000080',
        ],
      },
    ],
  },

  {
    section_name: 'Historic Miramar Redevelopment',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Job Access 30 Minute Transit Difference',
        layer_id: 'jobAccess30MinTransitDiffLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-18386, -5813.818, -3006.344, 0, 3000, 6000, 31870],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#FFCCCC',
          '#E0E0FF',
          '#99CCFF',
          '#3366FF',
          '#000080',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Household Density per acre Difference',
        layer_id: 'densityHouseHoldsAcreDiffLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-25, -3, -1, 0, 1, 10, 61],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#FFCCCC',
          '#E0E0FF',
          '#99CCFF',
          '#3366FF',
          '#000080',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Household Population Density per acres Difference',
        layer_id: 'householdPopulationDensityAcresDiffLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-46, -10, -1, 0, 1, 10, 161],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#FFCCCC',
          '#E0E0FF',
          '#99CCFF',
          '#3366FF',
          '#000080',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Households In NOAA Flood High 2070 Difference',
        layer_id: 'householdsInNoaaFloodHigh2070DiffLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-282, -5, 0, 0.01, 1, 20, 153],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#B4D2FF',
          '#99CCFF',
          '#3399FF',
          '#3366FF',
          '#000080',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Sum Total Jobs Difference',
        layer_id: 'sumTotalJobsDiffLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-14908, -100, -1, 0, 0.01, 100, 107083],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#FFCCCC',
          '#E0E0FF',
          '#99CCFF',
          '#3366FF',
          '#000080',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Job Access 45 Minute Transit Difference',
        layer_id: 'jobAccess45MinuteTransitLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-55892, -19311.953, -4400.052, 0, 7000, 8937.348, 26495],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#FFCCCC',
          '#E0E0FF',
          '#99CCFF',
          '#3366FF',
          '#000080',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Residential Price Difference',
        layer_id: 'residentialPriceDiffLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-504714, -1000, -10, 0, 5.93, 94.75, 253033],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#FFCCCC',
          '#E0E0FF',
          '#99CCFF',
          '#3366FF',
          '#000080',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Rent Burden Difference',
        layer_id: 'rentBurdenDiffLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-284, 0, 0.01, 50, 100, 200, 485],
        legend_value: [
          '#B22222',
          '#FF6666',
          '#E0E0FF',
          '#B4D2FF',
          '#99CCFF',
          '#3399FF',
          '#3366FF',
          '#000080',
        ],
      },
    ],
  },
  {
    section_name: 'BMPO Investment Analysis',
    section_details: [
      {
        type: 'layer',
        layer_name: 'Job Access 30 Minute Transit Comparison',
        layer_id: 'jobAccess30minuteTransitDiffInvAnyLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-19136, -7780.471, -4364.201, -2321.19, -658.114, 0, 241288],
        legend_value: [
          '#8B0000',
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#FF9999',
          '#FFCCCC',
          '#3366FF',
          '#000080',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Household Population Density per acre Comparison',
        layer_id: 'householdPopulationDensityAcresDiffInvAnyLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-31, -20, -10, 0, 0.01, 1, 22],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#FFCCCC',
          '#E0E0FF',
          '#99CCFF',
          '#3366FF',
          '#000080',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Household Density per acre Comparison',
        layer_id: 'densityHouseholdsAcreDiffInvAnyLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-4, -2.25, 0, 0.04, 5, 12],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#B4D2FF',
          '#99CCFF',
          '#3399FF',
          '#3366FF',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Residential Price Comparison',
        layer_id: 'residentialPriceDiffInvAnyLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-188618, -277.25, -44.25, 717.35, 982.63, 1294.06, 259250],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#FFCCCC',
          '#E0E0FF',
          '#99CCFF',
          '#3366FF',
          '#000080',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Sum Total Jobs Comparison',
        layer_id: 'sumTotalJobsDiffInvAnyLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-10317, -10, -1, 0, 5, 10000, 137831],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#FFCCCC',
          '#E0E0FF',
          '#99CCFF',
          '#3366FF',
          '#000080',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Households In NOAA Flood High 2070 Comparison',
        layer_id: 'householdsInNoaaFloodHigh2070DiffInvAnyLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-57, -1, 0, 0.01, 1, 5, 43],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#B4D2FF',
          '#99CCFF',
          '#3399FF',
          '#3366FF',
          '#000080',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Job Access 45 Minute Transit Comparison',
        layer_id: 'jobAccess45MinuteTransitDiffInvAnyLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [
          -47154, -20154.658, -12102.78, -4907.306, 4963.342, 62601.095, 700674,
        ],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#FF9999',
          '#FFCCCC',
          '#99CCFF',
          '#3366FF',
          '#000080',
        ],
      },
      {
        type: 'layer',
        layer_name: 'Rent Burden Comparison',
        layer_id: 'rentBurdenDiffInvAnyLayer',
        visible: false,
        defaultopacity: 0.5,
        opacity: 0.5,
        isOpacityControlOpen: false,
        collpsed: true,
        isDiffColored: true,
        legend_type: 'scale',
        legend_label: [-76, -10, -1, 0, 10, 30, 48],
        legend_value: [
          '#B22222',
          '#FF0000',
          '#FF6666',
          '#FFCCCC',
          '#E0E0FF',
          '#99CCFF',
          '#3366FF',
          '#000080',
        ],
      },
    ],
  },
];

export const getColorByIdAndLabel = (layerId, label) => {
  const randomColors = [
    '#edab00',
    '#02b1b0',
    '#046b99',
    '#009bdc',
    '#323a45',
    '#9fc7da',
    '#7F3C8D',
    '#11A579',
    '#3969AC',
    '#F2B701',
    '#E73F74',
    '#80BA5A',
    '#E68310',
    '#008695',
    '#CF1C90',
    '#f97b72',
    '#4b4b8f',
    '#A5AA99',
  ];

  // Traverse the sections
  for (const section of getDefaultCustomLegendMapping) {
    // Traverse the section details
    for (const detail of section.section_details) {
      // Check for direct layer_id match
      if (detail.type === 'layer' && detail.layer_id === layerId) {
        // Check for legend_label and find the index of the label
        if (detail.legend_label) {
          const index = detail.legend_label.indexOf(label);
          if (index !== -1) {
            return detail.legend_value[index];
          }
        }
        // Return a random color if no label match
        return randomColors[Math.floor(Math.random() * randomColors.length)];
      }

      // Traverse group details if group exists
      if (detail.type === 'group') {
        for (const subDetail of detail.group_details) {
          if (subDetail.layer_id === layerId) {
            // Find label in legend_label
            if (subDetail.legend_label) {
              const index = subDetail.legend_label.indexOf(label);
              if (index !== -1) {
                return subDetail.legend_value[index];
              }
            }
            // Return a random color if no label match
            return randomColors[Math.floor(Math.random() * randomColors.length)];
          }
        }
      }
    }
  }

  // Return a random color if nothing is found
  return randomColors[Math.floor(Math.random() * randomColors.length)];
};
